export const ORG_STATUS_VALUES = ['enterprise', 'team'] as const
export type UserOrgStatusType = (typeof ORG_STATUS_VALUES)[number]

export const COPILOT_PLAN_VALUES = ['edu', 'free', 'pro', 'pro_plus', 'max', 'enterprise', 'business'] as const
export type UserCopilotPlanType = (typeof COPILOT_PLAN_VALUES)[number]

export type CopilotPlanFlags = {
  hasCopilotEdu: boolean
  hasCopilotPro: boolean
  hasCopilotProPlus: boolean
  hasCopilotMax: boolean
  hasCopilotEnterprise: boolean
  hasCopilotBusiness: boolean
  hasCopilotFree: boolean
}

export function getCopilotPlanFlags(plan?: UserCopilotPlanType): CopilotPlanFlags {
  return {
    hasCopilotEdu: plan === 'edu',
    hasCopilotPro: plan === 'pro',
    hasCopilotProPlus: plan === 'pro_plus',
    hasCopilotMax: plan === 'max',
    hasCopilotEnterprise: plan === 'enterprise',
    hasCopilotBusiness: plan === 'business',
    hasCopilotFree: plan === 'free',
  }
}
